export default [
    'trotz',
    'wegen',
    'anstatt',
    'während',
    'außerhalb',
    'innerhalb',
    'anstelle',
    'aufgrund'
];


/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prepositions/genitivePrepositions.js
 **/